import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import utc from 'dayjs/plugin/utc';

dayjs.extend(weekday);
dayjs.extend(quarterOfYear);
dayjs.extend(utc);

const today = dayjs();

/**
 * Returns WTD, MTD, QTD, YTD, TTM ranges
 */
export function getToDateRanges() {
  const startOfWeek = today.weekday(0).startOf('day');         // Monday
  const startOfMonth = today.startOf('month');
  const startOfQuarter = today.startOf('quarter');
  const startOfYear = today.startOf('year');
  const startOfTTM = today.subtract(12, 'month').add(1, 'day').startOf('day');

  return {
    WTD: { start: startOfWeek.toDate(), end: today.endOf('day').toDate() },
    MTD: { start: startOfMonth.toDate(), end: today.endOf('day').toDate() },
    QTD: { start: startOfQuarter.toDate(), end: today.endOf('day').toDate() },
    YTD: { start: startOfYear.toDate(), end: today.endOf('day').toDate() },
    TTM: { start: startOfTTM.toDate(), end: today.endOf('day').toDate() }
  };
}